import { render, staticRenderFns } from "./administrative.vue?vue&type=template&id=5b42413e"
import script from "./administrative.vue?vue&type=script&lang=js"
export * from "./administrative.vue?vue&type=script&lang=js"
import style0 from "./administrative.vue?vue&type=style&index=0&id=5b42413e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports